import React, { Component } from 'react';
import Slider from 'react-slick';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import FadeIn from 'react-fade-in';
import Header from '../layout/Header';
import CountUp from 'react-countup';

export class Services_01 extends Component {
    render() {
        var slick_slider = {
          dots: false,
          arrow: false,
          autoplay: true,
          infinite: true,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,

          responsive: [{

            breakpoint: 1199,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3
            }
        },
        {
      
            breakpoint: 1024,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3
            }
        },
        {
      
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
        };
        return (
            <div className="site-main">
                <Header />
                {/* page-title */}
                <div className="ttm-page-title-row-01">
                    <div className="container-xl">
                    <div className="row">
                        <div className="col-md-12"> 
                        <div className="title-box">
                            <div className="page-title-heading">
                            <h1 className="title">Our Services</h1>
                            </div>{/* /.page-title-captions */}
                            <div className="breadcrumb-wrapper">
                            <span>
                                <a title="Homepage" href={process.env.PUBLIC_URL + '/'}>Home</a>
                            </span>
                            <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                            <span>Services 01</span>
                            </div>  
                        </div>
                        </div>{/* /.col-md-12 */}  
                    </div>{/* /.row */}  
                    </div>{/* /.container */}                      
                </div>
                {/* page-title end*/}


                <section class="ttm-row services-section-1 clearfix">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                                <div class="section-title res-991-mb-0">
                                    <div class="title-header mb-0">
                                        <h2 class="title">Giving your business some orignal ideas</h2>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 "> 
                                <div class="process-desc pl-90 res-1199-pl-0">
                                    <p class="desc-text">We strive to deliver best in-class software solutions that generate best trailing total return for business services across great mission goals generating billion net income</p>
                                </div>
                            </div>
                        </div>
                        <div class="ttm-horizontal_sep mb-35 mt-25"></div>
                        <div class="row row-equal-height ttm-vertical_sep style1">
                            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div class="featured-icon-box style1 first-child">
                                    <div class="featured-icon-thumnail">
                                        <img src="images/icon-01.png" loading="lazy" alt="Icon" class="rotate-img img-fluid" />
                                    </div>
                                    <div class="featured-content">
                                        <h3 class="featured-title-h3">
                                            <a href={process.env.PUBLIC_URL + '/content_engineering'} class="featured-title-h3-link">UI/UX creative <br /> design</a>
                                        </h3>
                                        <div class="featured-bottom-btn">
                                            <a href={process.env.PUBLIC_URL + '/content_engineering'} class="btn btn-inline"><i class="fas fa-long-arrow-alt-up"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div class="featured-icon-box style1 border-none">
                                    <div class="featured-icon-thumnail">
                                        <img src="images/icon-02.png" loading="lazy" alt="Icon" class="rotate-img img-fluid" />
                                    </div>
                                    <div class="featured-content">
                                        <h3 class="featured-title-h3">
                                        <a href={process.env.PUBLIC_URL + '/content_engineering'} class="featured-title-h3-link">Visual &amp; graphic design</a>
                                        </h3>
                                        <div class="featured-bottom-btn">
                                            <a href={process.env.PUBLIC_URL + '/content_engineering'} class="btn btn-inline"><i class="fas fa-long-arrow-alt-up"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div class="featured-icon-box style1 res-991-pl-0">
                                    <div class="featured-icon-thumnail">
                                        <img src="images/icon-03.png" loading="lazy" alt="Icon" class="rotate-img img-fluid" />
                                    </div>
                                    <div class="featured-content">
                                        <h3 class="featured-title-h3">
                                        <a href={process.env.PUBLIC_URL + '/content_engineering'} class="featured-title-h3-link">Digital marketing strategy</a>
                                        </h3>
                                        <div class="featured-bottom-btn">
                                            <a href={process.env.PUBLIC_URL + '/content_engineering'} class="btn btn-inline"><i class="fas fa-long-arrow-alt-up"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div class="featured-icon-box style1 last-child">
                                    <div class="featured-icon-thumnail">
                                        <img src="images/icon-04.png" loading="lazy" alt="Icon" class="rotate-img img-fluid" />
                                    </div>
                                    <div class="featured-content">
                                        <h3 class="featured-title-h3">
                                        <a href={process.env.PUBLIC_URL + '/content_engineering'} class="featured-title-h3-link">Effective customer support</a>
                                        </h3>
                                        <div class="featured-bottom-btn">
                                            <a href={process.env.PUBLIC_URL + '/content_engineering'} class="btn btn-inline"><i class="fas fa-long-arrow-alt-up"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="ttm-row bg-img3 ttm-bgimage-yes ttm-bg ttm-bgcolor-darkgrey clearfix">
                <div class="ttm-row-wrapper-bg-layer ttm-bg-layer ttm-bgcolor-darkgrey"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-2 col-md-12">
                                <div class="position-relative">
                                    <h2 class="row-heading-h3 res-991-pt-0">One Platform</h2>
                                </div>
                            </div>
                            <div class="col-lg-10 col-md-12">
                                <div class="position-relative res-991-mt-15">
                                    <h2 class="row-heading-h2">Endlesso</h2>
                                    <h2 class="row-heading-h2 pl-155 res-1199-pl-0"><span class="ttm-textcolor-skincolor">oportunities</span></h2>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-center mt-60 res-991-mt-20">
                            <div class="col-lg-6 col-md-12">
                                <div class="position-relative" data-aos="fade-right" data-aos-offset="200" data-aos-duration="1000" data-aos-once="true">
                                    <div class="ttm-textcolor-white">
                                        <p class="text-color-light">Web designing in a powerful way of just not a profession, however for our Company. We have a tendency to believe the idea that smart looking to believe the idea that smart looking.</p>
                                    </div>
                                    <div class="features-fid-item-wrapper res-991-mt-30 res-575-pb-10">
                                        <div class="row g-0 ttm-vertical_sep">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                                <div class="ttm-fid inside style1">
                                                    <div class="ttm-fid-contents text-left">
                                                        <h4 class="ttm-fid-inner">
                                                            <CountUp start={0} end={10} duration={10} />
                                                        </h4>
                                                        <h3 class="ttm-fid-title">Years of experience</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                                <div class="ttm-fid inside style1">
                                                    <div class="ttm-fid-contents text-left">
                                                    <h4 class="ttm-fid-inner">
                                                            <CountUp start={0} end={50} duration={50} />
                                                        </h4>
                                                        <h3 class="ttm-fid-title">Projects done</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12">
                                <div class="position-relative text-right pl-20 res-991-pl-0 res-991-mt-30" data-aos="fade-left" data-aos-offset="200" data-aos-duration="1000" data-aos-once="true">
                                    <img width="610" height="435" class="img-fluid" src="images/single-img-5.png" loading="lazy" alt="image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ttm-row tab-section-1 clearfix">
                    <div className="container-xl">
                        <div class="row align-items-center">
                            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                                <div class="section-title res-991-mb-0">
                                    <div class="title-header">
                                        <h2 class="title">Giving your business some orignal ideas</h2>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 "> 
                                <div class="process-desc pl-90 res-1199-pl-0">
                                    <p class="desc-text">We strive to deliver best in-class software solutions that generate best trailing total return for business services across great mission goals generating billion net income</p>
                                </div>
                            </div>
                        </div>
                      {/* row end */}
                      {/* row */}
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="ttm-tabs ttm-tab-style-classic style2 res-991-pt-20 res-991-pb-10">
                          <Tabs defaultIndex={2} onSelect={index => console.log(index)}>{/* tabs */}
                            <TabList className="tabs">
                              <Tab className="tab"><span><i className="flaticon flaticon-report" /> Hi-Tech</span></Tab>
                              <Tab className="tab"><span><i className="flaticon flaticon-computer" /> Media</span></Tab>
                              <Tab className="tab"><span><i className="flaticon flaticon-system" /> Automotive</span></Tab>
                              <Tab className="tab"><span><i className="flaticon flaticon-interaction" /> Banking</span></Tab>
                              <Tab className="tab"><span><i className="flaticon flaticon-analysis" /> Medical</span></Tab>
                              <Tab className="tab"><span><i className="flaticon flaticon-analysis" /> Automotive</span></Tab>
                            </TabList>
                            <div className="content-tab">
                              <FadeIn>
                              <TabPanel>
                                  <div className="content-inner">
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <div className="res-991-mt-30 res-991-mt-0">
                                          {/* ttm_single_image-wrapper */}
                                          <div className="ttm_single_image-wrapper">
                                            <img className="img-fluid" src="images/single-img-6.png" alt="single-img-three" />
                                          </div>{/* ttm_single_image-wrapper end */}
                                        </div>
                                      </div>
                                      <div class="col-xl-6 col-lg-12">
                                            <div class="tab-content-2 res-1199-mt-30 res-991-mt-10">
                                                <h3 class="tab-content-h3">Accelerating your information business standards</h3>
                                                <p>A results-driven mission combined with a make-it-happen inghu mindset. We needle forward for clients
                                                across the globe.</p>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4 col-md-4 col-sm-4">
                                                    <div class="">
                                                        <img width="150" height="100" class="img-fluid w-100" alt="tab-image" src="images/single-img-7.png" loading="lazy" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-8 col-md-8 col-sm-8 align-self-center">
                                                    <div class="res-575-mt-15">
                                                        <p>Anomica is a technology consulting anomicafirm with a strategy consulting arm. We accenture
                                                        is strategy the specialy loream great for aspiring.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-20">
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-gradient" />
                                                <span className="ttm-list-li-content">Complete software platform development </span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Practice maturity in hardware, firmware and middleware</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>{/* row end */}
                                  </div>{/* content-inner */}{/* row end*/}
                              </TabPanel>
                              <TabPanel>
                                  <div className="content-inner">
                                    <div className="row">
                                      <div class="col-xl-6 col-lg-12">
                                            <div class="tab-content-2 res-1199-mt-30 res-991-mt-0">
                                                <h3 class="tab-content-h3">Accelerating your information business standards</h3>
                                                <p>A results-driven mission combined with a make-it-happen inghu mindset. We needle forward for clients
                                                across the globe.</p>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4 col-md-4 col-sm-4">
                                                    <div class="">
                                                        <img width="150" height="100" class="img-fluid w-100" alt="tab-image" src="images/single-img-15.png" loading="lazy" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-8 col-md-8 col-sm-8 align-self-center">
                                                    <div class="res-575-mt-15">
                                                        <p>Anomica is a technology consulting anomicafirm with a strategy consulting arm. We accenture is
                                                        strategy the specialy loream great for aspiring.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-20">
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Complete software platform development </span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Practice maturity in hardware, firmware and middleware</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-lg-6">
                                        <div className="text-left">
                                          {/* ttm_single_image-wrapper */}
                                          <div className="ttm_single_image-wrapper res-1199-mt-30 pl-10">
                                            <img className="img-fluid" src="images/single-img-7.png" alt="single-img-three" />
                                          </div>{/* ttm_single_image-wrapper end */}
                                        </div>
                                      </div>
                                    </div>{/* row end */}
                                  </div>{/* content-inner */}{/* row end*/}
                              </TabPanel>
                              <TabPanel>
                              <div className="content-inner">
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <div className="res-991-mt-30 res-991-mt-0">
                                          {/* ttm_single_image-wrapper */}
                                          <div className="ttm_single_image-wrapper">
                                            <img className="img-fluid" src="images/single-img-6.png" alt="single-img-three" />
                                          </div>{/* ttm_single_image-wrapper end */}
                                        </div>
                                      </div>
                                      <div class="col-xl-6 col-lg-12">
                                            <div class="tab-content-2 res-1199-mt-30 res-991-mt-10">
                                                <h3 class="tab-content-h3">Accelerating your information business standards</h3>
                                                <p>A results-driven mission combined with a make-it-happen inghu mindset. We needle forward for clients across the globe.</p>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4 col-md-4 col-sm-4">
                                                    <div class="">
                                                        <img width="150" height="100" class="img-fluid w-100" alt="tab-image" src="images/single-img-7.png" loading="lazy" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-8 col-md-8 col-sm-8 align-self-center">
                                                    <div class="res-575-mt-15">
                                                        <p>Anomica is a technology consulting anomicafirm with a strategy consulting arm. We accenture is strategy the specialy loream great for aspiring.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-20">
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Complete software platform development </span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Practice maturity in hardware, firmware and middleware</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>{/* row end */}
                                  </div>{/* content-inner */}{/* row end*/}
                              </TabPanel>
                              <TabPanel>
                              <div className="content-inner">
                                    <div className="row">
                                      <div class="col-xl-6 col-lg-12">
                                            <div class="tab-content-2 res-1199-mt-30 res-991-mt-0">
                                                <h3 class="tab-content-h3">Accelerating your information business standards</h3>
                                                <p>A results-driven mission combined with a make-it-happen inghu mindset. We needle forward for clients across the globe.</p>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4 col-md-4 col-sm-4">
                                                    <div class="">
                                                        <img width="150" height="100" class="img-fluid w-100" alt="tab-image" src="images/single-img-15.png" loading="lazy" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-8 col-md-8 col-sm-8 align-self-center">
                                                    <div class="res-575-mt-15">
                                                        <p>Anomica is a technology consulting anomicafirm with a strategy consulting arm. We accenture is strategy the specialy loream great for aspiring.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-20">
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Complete software platform development </span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Practice maturity in hardware, firmware and middleware</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-lg-6">
                                        <div className="text-left">
                                          {/* ttm_single_image-wrapper */}
                                          <div className="ttm_single_image-wrapper res-1199-mt-30 pl-10">
                                            <img className="img-fluid" src="images/single-img-7.png" alt="single-img-three" />
                                          </div>{/* ttm_single_image-wrapper end */}
                                        </div>
                                      </div>
                                    </div>{/* row end */}
                                  </div>{/* content-inner */}{/* row end*/}
                              </TabPanel>
                              <TabPanel>
                              <div className="content-inner">
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <div className="res-991-mt-30 res-991-mt-0">
                                          {/* ttm_single_image-wrapper */}
                                          <div className="ttm_single_image-wrapper">
                                            <img className="img-fluid" src="images/single-img-6.png" alt="single-img-three" />
                                          </div>{/* ttm_single_image-wrapper end */}
                                        </div>
                                      </div>
                                      <div class="col-xl-6 col-lg-12">
                                            <div class="tab-content-2 res-1199-mt-30 res-991-mt-10">
                                                <h3 class="tab-content-h3">Accelerating your information business standards</h3>
                                                <p>A results-driven mission combined with a make-it-happen inghu mindset. We needle forward for clients across the globe.</p>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4 col-md-4 col-sm-4">
                                                    <div class="">
                                                        <img width="150" height="100" class="img-fluid w-100" alt="tab-image" src="images/single-img-7.png" loading="lazy" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-8 col-md-8 col-sm-8 align-self-center">
                                                    <div class="res-575-mt-15">
                                                        <p>Anomica is a technology consulting anomicafirm with a strategy consulting arm. We accenture is strategy the specialy loream great for aspiring.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-20">
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Complete software platform development </span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Practice maturity in hardware, firmware and middleware</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>{/* row end */}
                                  </div>{/* content-inner */}{/* row end*/}
                                  </TabPanel>
                              <TabPanel>
                              <div className="content-inner">
                                    <div className="row">
                                      <div class="col-xl-6 col-lg-12">
                                            <div class="tab-content-2 res-1199-mt-30 res-991-mt-0">
                                                <h3 class="tab-content-h3">Accelerating your information business standards</h3>
                                                <p>A results-driven mission combined with a make-it-happen inghu mindset. We needle forward for clients across the globe.</p>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4 col-md-4 col-sm-4">
                                                    <div class="">
                                                        <img width="150" height="100" class="img-fluid w-100" alt="tab-image" src="images/single-img-15.png" loading="lazy" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-8 col-md-8 col-sm-8 align-self-center">
                                                    <div class="res-575-mt-15">
                                                        <p>Anomica is a technology consulting anomicafirm with a strategy consulting arm. We accenture is strategy the specialy loream great for aspiring.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-20">
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Complete software platform development </span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Practice maturity in hardware, firmware and middleware</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics</span>
                                                </li>
                                                <li>
                                                <i className="fas fa-arrow-right ttm-textcolor-skincolor" />
                                                <span className="ttm-list-li-content">Device and field testing for electronics </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-lg-6">
                                        <div className="text-left">
                                          {/* ttm_single_image-wrapper */}
                                          <div className="ttm_single_image-wrapper res-1199-mt-30 pl-10">
                                            <img className="img-fluid" src="images/single-img-7.png" alt="single-img-three" />
                                          </div>{/* ttm_single_image-wrapper end */}
                                        </div>
                                      </div>
                                    </div>{/* row end */}
                                  </div>{/* content-inner */}{/* row end*/}
                              </TabPanel>
                              </FadeIn>
                            </div>
                          </Tabs>  {/* tabs end*/}
                          </div>
                        </div>
                      </div>
                    </div>
                </section>
                
            </div>
            )
    }
}


export default Services_01;